import './index.scss';

import type { NavItem } from '../navigation';

type SidebarMenuItemProps = {
  item: NavItem;
  active?: boolean;
  /** Icon rail: the label stays readable for assistive tech and shows as a tooltip. */
  collapsed?: boolean;
  onSelect: (item: NavItem) => void;
};

export const SidebarMenuItem = ({
  item,
  active = false,
  collapsed = false,
  onSelect,
}: SidebarMenuItemProps) => {
  const className = [
    'c-sidebar-menu-item',
    active && 'c-sidebar-menu-item--active',
    collapsed && 'c-sidebar-menu-item--collapsed',
  ]
    .filter(Boolean)
    .join(' ');
  const tooltip = collapsed ? item.label : undefined;
  const content = (
    <>
      <span className="c-sidebar-menu-item__icon">{item.icon}</span>
      <span className={collapsed ? 'c-sidebar-menu-item__sr-only' : 'c-sidebar-menu-item__label'}>
        {item.label}
      </span>
    </>
  );

  if (item.href) {
    return (
      <a
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        data-tooltip={tooltip}
        onClick={() => onSelect(item)}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={className}
      aria-current={active ? 'page' : undefined}
      data-tooltip={tooltip}
      onClick={() => onSelect(item)}
    >
      {content}
    </button>
  );
};
